import type ViewType from '../store/schema/ViewType';
import getStore from '../store/store';
import getAppropriateReadingPaneViewType from '../utils/getAppropriateReadingPaneViewType';

export default function getReadingPaneViewType(): ViewType {
    const readingPaneViewType = getStore().readingPaneViewType;
    const messageListExpansionType = getStore().messageListExpansionType;

    return getAppropriateReadingPaneViewType(messageListExpansionType, readingPaneViewType);
}
